/**
 * LoudDialog — styled replacements for the native alert/confirm/prompt.
 *
 * Promise-based (native confirm/prompt are synchronous; call sites use
 * .then / async-await instead):
 *   LoudDialog.alert('Saved')                          → Promise<void>
 *   LoudDialog.confirm('Delete?', { danger: true })    → Promise<boolean>
 *   LoudDialog.prompt('Name', { value: '', placeholder: '' }) → Promise<string|null>
 */
window.LoudDialog = (function() {
  'use strict';

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function open(kind, message, opts) {
    opts = opts || {};
    return new Promise(function(resolve) {
      var existing = document.querySelector('.ld-overlay');
      if (existing) existing.remove();

      var overlay = document.createElement('div');
      overlay.className = 'ld-overlay';
      overlay.innerHTML =
        '<div class="ld-dialog" role="dialog" aria-modal="true">' +
          '<div class="ld-message">' + esc(message) + '</div>' +
          (kind === 'prompt'
            ? '<input class="ld-input" type="text" value="' + esc(opts.value || '') + '"' +
              (opts.placeholder ? ' placeholder="' + esc(opts.placeholder) + '"' : '') + ' spellcheck="false">'
            : '') +
          '<div class="ld-actions">' +
            (kind !== 'alert'
              ? '<button type="button" class="ld-btn ld-btn--ghost" data-act="cancel">' + esc(opts.cancelLabel || 'Cancel') + '</button>'
              : '') +
            '<button type="button" class="ld-btn ld-btn--primary' + (opts.danger ? ' ld-btn--danger' : '') + '" data-act="ok">' +
              esc(opts.okLabel || 'OK') + '</button>' +
          '</div>' +
        '</div>';
      document.body.appendChild(overlay);

      var input = overlay.querySelector('.ld-input');
      var okBtn = overlay.querySelector('[data-act="ok"]');

      function close(result) {
        overlay.remove();
        document.removeEventListener('keydown', onKey, true);
        resolve(result);
      }
      function done() {
        if (kind === 'prompt') close(input ? input.value : '');
        else close(true);
      }
      function cancel() {
        if (kind === 'alert') close(undefined);
        else close(kind === 'prompt' ? null : false);
      }
      function onKey(e) {
        if (e.key === 'Escape') { e.stopPropagation(); cancel(); }
        if (e.key === 'Enter' && (kind !== 'prompt' || e.target === input)) { e.stopPropagation(); done(); }
      }

      okBtn.addEventListener('click', done);
      var cancelBtn = overlay.querySelector('[data-act="cancel"]');
      if (cancelBtn) cancelBtn.addEventListener('click', cancel);
      overlay.addEventListener('click', function(e) { if (e.target === overlay) cancel(); });
      document.addEventListener('keydown', onKey, true);

      requestAnimationFrame(function() {
        overlay.classList.add('is-open');
        if (input) { input.focus(); input.select(); }
        else okBtn.focus();
      });
    });
  }

  return {
    alert: function(message, opts) { return open('alert', message, opts); },
    confirm: function(message, opts) { return open('confirm', message, opts); },
    prompt: function(message, opts) { return open('prompt', message, opts); }
  };
})();
